import { render, staticRenderFns } from "./pageMyGoal.vue?vue&type=template&id=3ec56b6c&scoped=true"
import script from "./pageMyGoal.vue?vue&type=script&lang=js"
export * from "./pageMyGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec56b6c",
  null
  
)

export default component.exports